import { echartGaugeMonth } from '../common';

export function echartVieGaugeMonth(vis, datos) {
  document.querySelector('#tabViePrincCiutat').addEventListener('click', () => {
    requestAnimationFrame(() => {
      echartGaugeMonth(
        'chartViesMesActual',
        'chartViesMesAnterior',
        'no_dataViesMesActual',
        'no_dataViesMesAnterior',
        datos.resultset,
        'VIES PRINCIPALS DE LA\nCIUTAT: EVOLUCIÓ ',
        'VIES PRINCIPALS DE LA\nCIUTAT: EVOLUCIÓ ',
      );
    });
  });
}
